<template>
  <a 
    :href="href"
    :target="target"
    :download="download || undefined"
    :class='classes' 
    :style='styles'
    @click="onClick"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'c-button',
  props: {
    name: {
      type: String,
      default: null,
      required: false
    },
    href: {
      type: String,
      default: '#'
    },
    color: {
      type: String
    },
    bgColor: {
      type: String,
      default: '#88d32a'
    },
    borderColor: {
      type: String,
      default: 'transparent'
    },
    radius: {
      type: Number,
      default: 0
    },
    vertical: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: '_self'
    },
    download: {
      type: String,
      default: null
    },
    emitTo: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      $emitTo: null
    }
  },
  computed: {
    classes() {
      return [
        'c-button',
        { 'c-button--vertical': this.vertical },
        { 'c-button--rounded': this.radius > 50 }
      ]
    },
    styles() {
      return {
        color: this.color,
        backgroundColor: this.bgColor,
        borderColor: this.borderColor,
        borderRadius: `${this.radius}px`
      }
    }
  },
  mounted() {
    this.updateRadius()

    if (this.emitTo) {
      this.$emitTo = this.getFakeRoot(this)
    } else {
      this.$emitTo = this.$parent
    }
  },
  methods: {
    updateRadius() {
      if (this.radius < 100) return

      const { clientWidth, clientHeight } = this.$el

      if (clientWidth > clientHeight)
      {
        this.$el.style.height = `${clientWidth}px`
      }
      else if (clientWidth < clientHeight)
      {
        this.$el.style.width = `${clientHeight}px`
      }
    },
    onClick(event) {
      if (this.emitTo) event.preventDefault()
      this.$emitTo.$emit('clickbutton', this)
    },
    getFakeRoot($current) {
      if ($current.$parent.$options.name === this.emitTo)
      {
        return $current.$parent
      }
      return this.getFakeRoot($current.$parent)
    }
  }
}
</script>

<style lang='scss' scoped>
  .c-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    // margin: .3rem;
    padding: .5rem 1.5rem;
    overflow: hidden;
    cursor: pointer;
    text-decoration: none;
    box-shadow: 0 1px 2px rgba(0,0,0,.1);
    border: 2px solid transparent;

    &--vertical {
      flex-direction: column;
    }

    &--rounded {
      padding: 1rem;
    }

    & > * {
      margin: 0.225rem;
      z-index: 5;
    }

    &::before {
      content: '';
      opacity: 0.1;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      opacity: 0;
      background-color: #000;
      transition: all .3s;
    }
    
    &:hover {
      &::before {
        opacity: 0.1;
      }
    }
  }
</style>
